/*
 * Duallys Only Affirm ALA messaging refresh
 * Keeps Affirm promotional messages current after Shopify sections, variant prices,
 * filters, search results, and product cards render or update.
 */
(function () {
  'use strict';

  var refreshTimer = null;
  var styleTimer = null;
  var affirmRetryTimer = null;
  var affirmRetryCount = 0;
  var affirmReferringUrl = 'https://www.duallysonly.com';
  var affirmPublicApiKey = '0B0I4K1ETDS4PS4N';
  var affirmScriptUrl = 'https://cdn1.affirm.com/js/v2/affirm.js';

  function ensureAffirmRuntime() {
    if (window.affirm) return;

    window._affirm_config = window._affirm_config || {
      public_api_key: affirmPublicApiKey,
      script: affirmScriptUrl
    };

    (function (l, g, m, e, a, f, b) {
      var d;
      var c = l[m] || {};
      var h = document.createElement(f);
      var n = document.getElementsByTagName(f)[0];
      var k = function (obj, method, command) {
        return function () {
          obj[method]._.push([command, arguments]);
        };
      };

      c[e] = k(c, e, 'set');
      d = c[e];
      c[a] = {};
      c[a]._ = [];
      d._ = [];
      c[a][b] = k(c, a, b);

      var methods = 'set add save post open empty reset on off trigger ready setProduct'.split(' ');
      for (var i = 0; i < methods.length; i += 1) {
        d[methods[i]] = k(c, e, methods[i]);
      }

      var getters = ['get', 'token', 'url', 'items'];
      for (var j = 0; j < getters.length; j += 1) {
        d[getters[j]] = function () {};
      }

      h.async = true;
      h.src = g[f];
      if (n && n.parentNode) {
        n.parentNode.insertBefore(h, n);
      } else {
        document.head.appendChild(h);
      }
      delete g[f];
      d(g);
      l[m] = c;
    })(window, window._affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready');
  }

  function scheduleAffirmReadyRetry() {
    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') return;
    if (affirmRetryCount >= 40) return;

    affirmRetryCount += 1;
    if (affirmRetryTimer) window.clearTimeout(affirmRetryTimer);
    affirmRetryTimer = window.setTimeout(function () {
      ensureAffirmRuntime();
      refreshAffirm();
      scheduleAffirmReadyRetry();
    }, 250);
  }

  function addAffirmReferringUrl(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;

    var links = scope.querySelectorAll('a[href*="affirm.com/apps/prequal"]');
    for (var i = 0; i < links.length; i += 1) {
      var href = links[i].getAttribute('href');
      if (!href || href.indexOf('referring_url=') !== -1) continue;

      links[i].setAttribute(
        'href',
        href + (href.indexOf('?') === -1 ? '?' : '&') + 'referring_url=' + encodeURIComponent(affirmReferringUrl)
      );
    }
  }

  function scheduleStyleAffirmMessages(delay) {
    if (styleTimer) {
      window.clearTimeout(styleTimer);
    }

    styleTimer = window.setTimeout(function () {
      styleAffirmMessages();
    }, typeof delay === 'number' ? delay : 120);
  }

  function styleAffirmMessages() {
    addAffirmReferringUrl(document);

    var promos = document.querySelectorAll('.affirm-as-low-as.duallys-affirm-promo');
    for (var i = 0; i < promos.length; i += 1) {
      styleAffirmMessage(promos[i]);
    }
  }

  function styleAffirmMessage(promo) {
    if (!promo || !promo.textContent) return;

    promo.classList.add('duallys-affirm-color-split');

    var textNodes = [];
    var walker = document.createTreeWalker(
      promo,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;

          var parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          if (parent.closest('script, style, .duallys-affirm-amount, .duallys-affirm-logo')) return NodeFilter.FILTER_REJECT;

          if (/(Starting\s+at|\$[\d,.]+\/mo|Affirm)/i.test(node.nodeValue)) {
            return NodeFilter.FILTER_ACCEPT;
          }

          return NodeFilter.FILTER_REJECT;
        }
      }
    );

    var currentNode;
    while ((currentNode = walker.nextNode())) {
      textNodes.push(currentNode);
    }

    for (var i = 0; i < textNodes.length; i += 1) {
      splitAffirmTextNode(textNodes[i]);
    }
  }

  function createAffirmLogo() {
    var logo = document.createElement('span');
    logo.className = 'duallys-affirm-logo';
    logo.setAttribute('aria-label', 'Affirm');
    logo.textContent = 'affirm';
    return logo;
  }

  function splitAffirmTextNode(textNode) {
    var text = textNode.nodeValue;
    text = text.replace(/^\s*Starting\s+at\s+/i, '');
    text = text.replace(/\s+Starting\s+at\s+/gi, ' ');

    var pattern = /(\$[\d,.]+\/mo|\bAffirm\b\.?)/gi;
    if (!pattern.test(text)) {
      if (text !== textNode.nodeValue) {
        textNode.nodeValue = text;
      }
      return;
    }

    pattern.lastIndex = 0;

    var fragment = document.createDocumentFragment();
    var lastIndex = 0;
    var match;

    while ((match = pattern.exec(text)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }

      if (/^\$/i.test(match[0])) {
        var amountSpan = document.createElement('span');
        amountSpan.className = 'duallys-affirm-amount';
        amountSpan.textContent = match[0];
        fragment.appendChild(amountSpan);
      } else {
        fragment.appendChild(createAffirmLogo());
      }

      lastIndex = pattern.lastIndex;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    if (textNode.parentNode) {
      textNode.parentNode.replaceChild(fragment, textNode);
    }
  }

  function refreshAffirm() {
    if (refreshTimer) {
      window.clearTimeout(refreshTimer);
    }

    refreshTimer = window.setTimeout(function () {
      if (!document.querySelector('.affirm-as-low-as')) return;
      ensureAffirmRuntime();
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        if (typeof window.affirm.ui.ready === 'function') {
          window.affirm.ui.ready(function () {
            window.affirm.ui.refresh();
            scheduleStyleAffirmMessages(300);
          });
        } else {
          window.affirm.ui.refresh();
          scheduleStyleAffirmMessages(300);
        }
      } else {
        scheduleStyleAffirmMessages(300);
        scheduleAffirmReadyRetry();
      }
    }, 150);
  }

  function syncProductAffirmAmount(root) {
    var scope = root || document;
    var productForm = scope.querySelector('product-info form[action*="/cart/add"], form[action*="/cart/add"]');
    var affirmPromo = scope.querySelector('.duallys-affirm-promo--product');
    if (!productForm || !affirmPromo) return;

    var variantInput = productForm.querySelector('[name="id"]');
    if (!variantInput) return;

    var variantId = variantInput.value;
    if (!variantId || !window.ShopifyAnalytics || !window.ShopifyAnalytics.meta || !window.ShopifyAnalytics.meta.product) return;

    var variants = window.ShopifyAnalytics.meta.product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === String(variantId) && variants[i].price) {
        affirmPromo.setAttribute('data-amount', variants[i].price);
        break;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    addAffirmReferringUrl(document);
    ensureAffirmRuntime();
    syncProductAffirmAmount(document);
    refreshAffirm();
    scheduleAffirmReadyRetry();
    scheduleStyleAffirmMessages(800);
    window.setTimeout(styleAffirmMessages, 1500);
    window.setTimeout(styleAffirmMessages, 3000);
    window.setTimeout(styleAffirmMessages, 5000);

    document.addEventListener('variant:change', function () {
      syncProductAffirmAmount(document);
      refreshAffirm();
    });

    document.addEventListener('shopify:section:load', function (event) {
      syncProductAffirmAmount(event.target);
      refreshAffirm();
    });

    document.addEventListener('shopify:section:select', function (event) {
      syncProductAffirmAmount(event.target);
      refreshAffirm();
    });

    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = false;
      var shouldStyle = false;

      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        var target = mutation.target;

        if (target && target.nodeType === 1 && target.closest && target.closest('.affirm-as-low-as')) {
          shouldStyle = true;
          continue;
        }

        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          for (var n = 0; n < mutation.addedNodes.length; n += 1) {
            var node = mutation.addedNodes[n];
            if (node.nodeType === 3 && node.parentElement && node.parentElement.closest('.affirm-as-low-as')) {
              shouldStyle = true;
              continue;
            }
            if (node.nodeType !== 1) continue;
            if (node.closest && node.closest('.affirm-as-low-as')) {
              shouldStyle = true;
            }
            if (
              node.matches &&
              (node.matches('.affirm-as-low-as') || node.matches('.price') || node.matches('.product') || node.matches('.grid__item'))
            ) {
              shouldRefresh = true;
            }
            if (node.querySelector && node.querySelector('.affirm-as-low-as')) {
              shouldRefresh = true;
              shouldStyle = true;
            }
          }
        }
      }

      if (shouldRefresh) {
        syncProductAffirmAmount(document);
        refreshAffirm();
      } else if (shouldStyle) {
        scheduleStyleAffirmMessages(60);
      }
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  });
})();
